export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'https://api.future-farm.rotas-square.co.za'
export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL ?? 'https://cdn.future-farm.rotas-square.co.za'

export const cdnImage = (filename: string) => `${CDN_BASE_URL}/${filename}`
